import React from 'react'
import styled from 'styled-components'
import { Button } from '@streamr/streamr-layout'
import QuickstartSteps from './QuickstartSteps'
import Spacer from '~shared/Spacer'
import ButtonWrapper from '~shared/ButtonWrapper'
import urls from '~utils/urls'
import useTranslation from '~utils/useTranslation'

const ButtonsSpacer = styled(Spacer)`
    text-align: center;
`

const Quickstart = (props) => {
    const { t } = useTranslation()

    return (
        <div {...props}>
            <QuickstartSteps />
            <ButtonsSpacer head="48px,80px,104px">
                <ButtonWrapper>
                    <Button
                        tag="a"
                        href={urls.apps.core}
                        kind="primary"
                        size="big"
                    >
                        {t('learn.marketplace.quickstart.connectWallet')}
                    </Button>
                </ButtonWrapper>
            </ButtonsSpacer>
        </div>
    )
}

export default styled(Quickstart)``
